export default __webpack_public_path__ + "static/media/paper-airplane.e3381fc6.svg";